import type {ReactElement} from 'react';
import React from 'react';
import {useAppSelector} from '@/hooks';
import {PosterEditorWebBottomBarButton} from '@Components/poster-editor/components/poster-editor-web-bottom-bar-button/poster-editor-web-bottom-bar-button';
import {PosterEditorWebBottomBar} from '@Components/poster-editor/components/poster-editor-web-bottom-bar';
import {useIsCurrentPageVideo} from '@Hooks/poster-editor/useIsCurrentPageVideo';

export function PosterEditorWebBottomBarWrapper(): ReactElement | null {
  const isTimelineModeActive = useAppSelector((state) => {
    return state.posterEditor.isTimelineModeActive;
  });

  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });

  const isCurrentPageVideo = useIsCurrentPageVideo();

  if (isVersionHistoryModeActive || !isCurrentPageVideo) {
    return null;
  }

  if (isTimelineModeActive) {
    return <PosterEditorWebBottomBar />;
  }

  return <PosterEditorWebBottomBarButton />;
}
